import React, { Component } from 'react'
import './navtabs.scss'

class NavTabs extends Component {
	constructor(props) {
		super(props)
		this.state = {
			classes: props.classes ? props.classes : '',
			links: props.links ? props.links : '',
			selected: props.selected ? props.selected : 0
		}
	}

	selected = (selected) => {
		const id = selected.currentTarget.dataset.id
		this.setState({ selected: id })
		//let parent = selected.currentTarget.parentNode
	}

	render() {
		const classes = ['vbui--navtabs', this.props.classes].join(' ')
		return <div className={classes}>{this.props.children}</div>
	}
}

export default NavTabs
